// Data sevice
import axios from 'axios'
import authHeader from './auth-header'
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
const API_URL = process.env.VUE_APP_API_URL;

class GroupsService {

    index() {
        return axios.get(API_URL + 'groups', { headers: authHeader() })
    }
    show(id) {
        return axios.get(API_URL + 'groups/' + id, { headers: authHeader() })
    }
    subCategoryGroups(subcategoryId) {
        console.log(`Calling API for subcategory groups with ID: ${subcategoryId}`);
        return axios.get(`${API_URL}subcategory-groups/${subcategoryId}`, { headers: authHeader() });
      }

    store(resource) {
        return axios.post(API_URL + 'groups', resource, { headers: authHeader() })
    }
    update(resource) {
        return axios.put(API_URL + 'groups/' + resource.id, resource, { headers: authHeader() })
    }
    delete(resource) {
        return axios.delete(API_URL + 'groups/' + resource.id, { headers: authHeader() })
    }
}

export default new GroupsService()